import { defineStore } from 'pinia'

import type { DisciplineScheduleStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'
import { createDisciplineScheduleState } from './state'

export const useDisciplineScheduleStore = defineStore('discipline-schedule', {
  state: (): DisciplineScheduleStore => createDisciplineScheduleState(),
  actions,
  getters,
})
